import { autoinject } from 'aurelia-framework';
import { AcurityTable } from '~/components/acurity-table/acurity-table';
import { DrilldownCommonModel } from '~/components/dialog/dialog-with-tabs/drilldown-model';
import { ATOInterfacesModel } from '~/forms/ato-interfaces/models/ato-interfaces-model';
import { ResponseBean } from '~/forms/ato-interfaces/models/response-bean';
import { ColumnDefinitionMap } from '~/models/column-definition';

@autoinject
export class RawDataTab extends DrilldownCommonModel {
	public requestTable: AcurityTable;
	private requestTableData: object[] = [];
	public responseTable: AcurityTable;
	private responseTableData: object[] = [];
	private viewRequestAsTable: boolean = false;
	private viewResponseAsTable: boolean = false;

	constructor(
		template: string,
		data: ATOInterfacesModel,
		tableColumnDefinitions: ColumnDefinitionMap,
	) {
		super(template, data, tableColumnDefinitions);

		if (!data.responseBean) {
			return;
		}

		this.populateTableData(data.responseBean);
	}

	private populateTableData(responseBean: ResponseBean) {
		if (responseBean.request && responseBean.request.fieldMap) {
			const requestMap = responseBean.request.fieldMap;
			for (const field of Object.keys(requestMap)) {
				this.requestTableData.push({
					field,
					value: requestMap[field],
				});
			}
			this.viewRequestAsTable = true;
		}

		if (responseBean.response && responseBean.response.fieldMap) {
			const responseMap = responseBean.response.fieldMap;
			for (const field of Object.keys(responseMap)) {
				this.responseTableData.push({
					field,
					value: responseMap[field].replace(/[|]/g, '\n'),
				});
			}
			this.viewResponseAsTable = true;
		}
	}

	public toggleRawData() {
		if (this.requestTableData.length > 0) {
			this.viewRequestAsTable = !this.viewRequestAsTable;
		}
		if (this.responseTableData.length > 0) {
			this.viewResponseAsTable = !this.viewResponseAsTable;
		}
	}
}
